//#region types
import { FormEnums } from "models/enums";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { AgreementFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
import { FilterHelper, QueryStateHelper } from "utils/helpers";

function useAgreementReportFilterDefinition() {
  const apiToReportFilterFormatter = async (
    filter: WintSuperkollAPIModel.AgreementFilter
  ): Promise<AgreementFormTypes.Filter> => {
    const reportFilter: AgreementFormTypes.Filter = {
      name: filter.name,
      description: filter.description,
      counterPart: filter.counterPart,
      active: filter.active,
    };

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.Agreement.Filter.AgreementPeriod,
      filter.start,
      filter.end
    );

    FilterHelper.setNumberRange(
      reportFilter,
      FormFieldConstants.Agreement.Filter.MonthlyCostPeriod,
      filter.minMonthlyCost,
      filter.maxMonthlyCost
    );

    FilterHelper.setNumberRange(
      reportFilter,
      FormFieldConstants.Agreement.Filter.TotalCostPeriod,
      filter.minTotalCost,
      filter.maxTotalCost
    );

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<AgreementFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
        description: {
          label: TranslationKeys.Common.Description,
          type: FormEnums.FormFieldType.TEXT,
        },
        counterPart: {
          label: TranslationKeys.Agreement.Counterpart,
          type: FormEnums.FormFieldType.TEXT,
        },
        agreementPeriod: {
          label: TranslationKeys.Common.Period,
          type: FormEnums.FormFieldType.DATERANGE,
        },
        monthlyCostPeriod: {
          label: TranslationKeys.Agreement.MonthlyCost,
          type: FormEnums.FormFieldType.CURRENCYRANGE,
        },
        totalCostPeriod: {
          label: TranslationKeys.Agreement.TotalCost,
          type: FormEnums.FormFieldType.CURRENCYRANGE,
        },
        active: {
          label: TranslationKeys.Common.Active,
          type: FormEnums.FormFieldType.BOOLEANSELECTION,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<AgreementFormTypes.Filter> = {
    name: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Agreement.Filter.Name),
    description: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Agreement.Filter.Description),
    counterPart: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Agreement.Filter.CounterPart),
    active: QueryStateHelper.booleanQueryEncoder(FormFieldConstants.Agreement.Filter.Active),
    agreementPeriod: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Agreement.Filter.AgreementPeriod),
    monthlyCostPeriod: QueryStateHelper.numberRangeQueryEncoder(FormFieldConstants.Agreement.Filter.MonthlyCostPeriod),
    totalCostPeriod: QueryStateHelper.numberRangeQueryEncoder(FormFieldConstants.Agreement.Filter.TotalCostPeriod),
  };

  return { filterQueryStateHandler, filterFormFields, apiToReportFilterFormatter };
}

export default useAgreementReportFilterDefinition;
